// src/services/api/offlineSales/receivables.js
// Endpoints per rettzy-backend/src/modules/offlineSales/routes/receivables.routes.js
import { apiClient } from '../base';

export const getAgingSummary = async (params = {}) => {
  const response = await apiClient.get('/offline-sales/receivables', { params });
  return response.data;
};

export const getCustomerStatement = async (customerId, params = {}) => {
  const response = await apiClient.get(`/offline-sales/receivables/customers/${customerId}`, { params });
  return response.data;
};
